import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { repartitionTypeOptions } from '../../services/ref';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Component({
    selector: 'funds-initial-payment',
    templateUrl: './funds-initial-payment.component.html',
    styleUrls: ['./funds-initial-payment.component.scss'],
    standalone: false
})
export class FundsInitialPaymentComponent implements OnInit, OnChanges {
  fundForm: UntypedFormArray;

  options: FormControlOption[] = [];
  hasSwisslifeProduct: boolean = false;

  repartitionTypeOptions = repartitionTypeOptions;

  @Input() derrors: any = undefined;
  @Input() formGroup: UntypedFormGroup;
  countries: any[];

  constructor(
    private controlContainer: ControlContainer,
    private subscriptionFacade: SubscriptionFacadeService,
    private referenceDao: ReferenceDao,
  ) {}

  ngOnInit() {
    this.referenceDao.getCountries().subscribe(countries => {
      this.fundForm = this.formGroup.get('fundsOriginList') as UntypedFormArray;
      this.options =
        this.subscriptionFacade.getPledgeOptions()?.fundsOriginOptions;
      this.countries = countries;
      const pledge = this.subscriptionFacade.getPledge();
      this.hasSwisslifeProduct = (pledge?.products || []).some(
        product => product?.parameters?.partnerFlux === 'SWISSLIFE',
      );
    });
  }

  addFields() {
    this.fundForm.push(
      new UntypedFormGroup({
        date: new UntypedFormControl(new Date(), [Validators.required]),
        fundOrigin: new UntypedFormControl('', [Validators.required]),
        distribution: new UntypedFormControl(100, [Validators.required]),
        repartitionType: new UntypedFormControl('PERCENTAGE', [
          Validators.required,
        ]),
        fundOriginOtherDetail: new UntypedFormControl(''),
        description: new UntypedFormControl(
          '',
          this.hasSwisslifeProduct ? [Validators.required] : [],
        ),
        fundEmmiter: new UntypedFormControl(
          '',
          this.hasSwisslifeProduct ? [Validators.required] : [],
        ),
        financialInstitution: new UntypedFormControl(
          '',
          this.hasSwisslifeProduct ? [Validators.required] : [],
        ),
        source: new UntypedFormControl('FR', [Validators.required]),
      }),
    );

    this.fundForm.markAsUntouched();
  }

  deleteFields(index) {
    this.fundForm.removeAt(index);
  }

  ngOnChanges() {
    if (this.fundForm)
      this.fundForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
